import Vue from '../lib/utils/vue3compat/vue.js?vue3';
import VueApollo from '../lib/utils/vue3compat/vue_apollo.js?vue3';
import { initVueApp } from '../lib/utils/vue3compat/init_vue_app.js?vue3';
import createDefaultClient from '../lib/graphql.js?vue3';

import {
  VISIBILITY_LEVEL_PRIVATE_STRING,
  VISIBILITY_LEVELS_INTEGER_TO_STRING,
} from '~/visibility_level/constants';
import Translate from '~/vue_shared/translate';

Vue.use(VueApollo);
Vue.use(Translate);

export default function appFactory(el, Component) {
  if (!el) {
    return false;
  }

  const apolloProvider = new VueApollo({
    defaultClient: createDefaultClient(),
  });

  const {
    visibilityLevels = '[]',
    selectedLevel,
    multipleLevelsRestricted,
    canReportSpam,
    reportAbusePath,
    ...restDataset
  } = el.dataset;

  return initVueApp({
    el,
    name: 'SnippetsRoot',
    apolloProvider,
    provide: {
      visibilityLevels: JSON.parse(visibilityLevels),
      selectedLevel:
        VISIBILITY_LEVELS_INTEGER_TO_STRING[selectedLevel] ?? VISIBILITY_LEVEL_PRIVATE_STRING,
      multipleLevelsRestricted: 'multipleLevelsRestricted' in el.dataset,
      reportAbusePath,
      canReportSpam,
    },
    component: Component,
    props: {
      ...restDataset,
    },
  });
}
